import React from 'react'

import { GenericForm } from 'components'
import PropTypes from 'prop-types'
import validator from 'validator'

import PasswordInput from '../../../../../../../../../components/forms/PasswordInput'
import colors from '../../../../../../../../../components/hocs/colors'

/**
 * Gets base form fields
 */
const getFormFields = () => [
  {
    Component: PasswordInput,
    formItemProps: { label: 'Current Password' },
    inputProps: {
      'aria-label': 'Enter your current password for verification',
      type: 'password',
    },
    name: 'currentPassword',
  },
  {
    Component: PasswordInput,
    formItemProps: { label: 'New Password' },
    inputProps: {
      'aria-label': 'Enter your new password (minimum 6 characters)',
      type: 'password',
    },
    name: 'newPassword',
  },
  {
    Component: PasswordInput,
    formItemProps: { label: 'Confirm New Password' },
    inputProps: {
      'aria-label': 'Confirm your new password',
      type: 'password',
    },
    name: 'newPasswordConfirmation',
  },
]

/**
 * Validation Helpers
 */
const isLength = (value = '') =>
  validator.isLength(value, { min: 6 }) ? undefined : 'Invalid Password'

const checkEquality = (value, candidate) =>
  value === candidate ? undefined : 'Passwords must match'

const validate = ({ currentPassword = '', newPassword = '', newPasswordConfirmation = '' }) => ({
  currentPassword: isLength(currentPassword),
  newPassword: isLength(newPassword),
  newPasswordConfirmation:
    isLength(newPasswordConfirmation) || checkEquality(newPassword, newPasswordConfirmation),
})

const ChangePasswordForm = ({ onSubmit }) => (
  <GenericForm
    fields={getFormFields()}
    formProps={{ onSubmit, validate }}
    submitButtonContent="Change Password"
    submitButtonProps={{ block: true, style: { backgroundColor: colors.blue3, marginTop: 16 } }}
  />
)

ChangePasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default ChangePasswordForm
